import { Link } from "react-router-dom";
import NewsCard from "@/components/base/NewsCard";
import { getCategories, getNewsByCategory, filterAndSort } from "@/utils/news";

export default function FeaturedColumns() {
  const categories = getCategories();

  return (
    <div className="flex flex-col gap-12">
      {categories.map((cat, idx) => {
        const items = filterAndSort(getNewsByCategory(cat.key), { sortBy: "latest" }).slice(0, 6);
        return (
          <section
            key={cat.slug}
            className={`w-full rounded-lg py-6 ${idx % 2 === 0 ? "" : ""}`}
          >
            <div className="flex items-end justify-between mb-5">
              <div className="flex items-center gap-3">
                <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
                <h2 className="font-heading font-black text-xl md:text-2xl text-foreground-950">
                  {cat.name}
                </h2>
                <span className="hidden sm:inline text-sm text-foreground-500 ml-1">
                  / {cat.description.split("，")[0]}
                </span>
              </div>
              <Link
                to={`/category/${cat.slug}`}
                className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
              >
                查看更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {items.map((item) => (
                <NewsCard key={item.id} item={item} variant="grid" showCategory={false} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}